<template>
  <div style="width: 100%">
    <v-file-input
      class="pt-0 mt-0"
      :loading="IsUploaded"
      v-model="files"
      accept="video/*"
      placeholder="sube tu instagram storie"
      prepend-icon="mdi-cloud-upload"
      @change="uploadVideo"
      show-size
    />
    <v-card v-if="storyUrl" max-width="250" flat outlined>
      <v-card-text class="pa-0">
        <video
          :src="storyUrl"
          id="video"
          :controls="false"
          autoplay
          muted
          :style="{ width: 'inherit', height: 'auto' }"
        />
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn icon @click="deleteVideo(storyUrl)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "FileInput",
  props: ["IsUploaded", "storyUrl"],
  data: () => ({
    imgSrc: "",
    dialogCroper: false,
    imageData: "",
    fileName: "",
    dialogLoader: false,
    files: []
  }),
  methods: {
    deleteVideo(url) {
      this.$emit("deleteVideo", url);
    },
    uploadVideo() {
      this.$emit("uploadVideo", this.files);
    }
  }
};
</script>
